<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <!--<NeList ref="neCms" :neArr='netype' :select='neClick'></NeList>-->
      <OrganizationalTree ref="organizationalTree" @qryNeids = 'qryNeidsChange' :nodeSelectProp='getNode' :neid="neid">
        <template v-slot:organizationalIcon_solt>
          <OrganizationalIcon ></OrganizationalIcon>
        </template>
      </OrganizationalTree>

    </template>
    <template v-slot:right_view>
      <div>
        <UsersTableMenu @methodEnum='methodEnum'></UsersTableMenu>
        <UsersTable ref="userstable" :qryNeids = 'qryNeids'></UsersTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import UsersTable from '../../../../components/subscriberMicro/mcsSubscriber/user/UsersTable';
import UsersTableMenu from '../../../../components/subscriberMicro/mcsSubscriber/user/UsersTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
// import NeList from '../../../../components/common/NeList';
import OrganizationalTree from '../../../../components/subscriberMicro/mcsSubscriber/OrganizationalTree';
import OrganizationalIcon from '../../../../components/subscriberMicro/mcsSubscriber/OrganizationalIcon';

export default {
  name: 'UserMainPage',
  components: {
    // NeList,
    UsersTable,
    UsersTableMenu,
    BasicLayout,
    OrganizationalTree,
    OrganizationalIcon
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('SubscriberIms.organization')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.menuTitleUserMcs')
      },
      netype: [2110],
      qryNeids: []
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.userstable.openAddUserPage();
          break;
        case 'mod':
          this.$refs.userstable.openModUserPage();
          break;
        case 'del':
          this.$refs.userstable.delUsers();
          break;
        case 'qryGroupList':
          this.$refs.userstable.openQryGroupListPage();
          break;
        case 'addBlackList':
          this.$refs.userstable.openAddBlackListPage();
          break;
        case 'qryBlackList':
          this.$refs.userstable.openQryBlackListPage();
          break;
        case 'addAreaList':
          this.$refs.userstable.openAddAreaListPage();
          break;
        case 'qryAreaList':
          this.$refs.userstable.openQryAreaListPage();
          break;
        case 'export':
          this.$refs.userstable.exportData();
          break;
        case 'refresh':
          this.$refs.userstable.reFreshByNoCondition();
          break;
        case 'search':
          this.$refs.userstable.openSearchPage();
          break;
        default:
      }
    },
    neClick() {
      this.$refs.userstable.getGridData(this.$refs.neCms.getNe());
    },
    getNode(node) {
      this.$refs.userstable.getGridData(node);
      this.node = node;
    },
    qryNeidsChange(qryNeids) {
      this.qryNeids = qryNeids
    },
  },
  mounted() {
    this.$refs.organizationalTree.getOrganizationalTree();
  }
};
</script>

<style scoped>

</style>
